<template>
  <div id="app">
    <div class="tit-block">
      <img class="logo" src="./assets/logo1.png" alt="">
      圣湘生物 （688289）— 生命科技人人可及
      <div
        v-if="$route.name!== 'register'"
        class="login-out"
        @click="loginOut"
      >退出</div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import { loginOutApi } from '@/utils/api.js'
export default {
  name: 'App',
  created () {},
  methods: {
    async loginOut () {
      await loginOutApi()
      this.$router.push({ name: 'register' })
    }
  }
}
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.tit-block {
  height: 50px;
  line-height: 50px;
  background: #eeeeee;
  border-bottom: 1px solid #ed1846;
}
.tit-block .logo {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin: 0 8px;
}
.login-out {
  float:right;
  height: 36px;
  line-height: 36px;
  margin: 5px 20px 0 0;
  color:#ed1846;
  border: 1px solid #ed1846;
  border-radius: 4px;
  padding: 0 15px;
}
/* .el-button--primary {
  background-color: #ed1846;
  border-color: #ed1846;
}
.el-button--primary.is-plain {
  background: #fae7ec;
  border: 1px solid #f35678;
  color: #ed1846;
}
/deep/.el-tabs__item.is-active {
  color: #ed1846;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue